<ng-container *ngIf="!customer_creation">
	<div class="row">
		<div class="col-md-6  text-left">
			<button class="btn btn-accent" (click)="$event.preventDefault();$event.stopPropagation();addNote();" id="addnote">Add Note</button>
			<button 
				*ngIf="speechRecognitionService?.getIsSupported()"
				type="button"
				class="btn btn-primary ml-2"
				[title]="isVoiceRecordingNote ? 'Stop Recording' : 'Add Note by Voice'"
				(click)="$event.preventDefault();$event.stopPropagation();toggleVoiceAddNote();"
				[class.voice-active]="isVoiceRecordingNote">
				<i class="material-icons" [class.text-warning]="isVoiceRecordingNote" [class.voice-pulse]="isVoiceRecordingNote">{{ isVoiceRecordingNote ? 'mic' : 'mic_none' }}</i>
				<span class="badge badge-recording" *ngIf="isVoiceRecordingNote">Recording…</span>
				<span class="ml-1">Voice Note</span>
			</button>
		</div>
		<div class="col-md-6 text-right">
			<button class="btn btn-primary" (click)="$event.preventDefault();$event.stopPropagation();onSubmit()">Save</button>
		</div>
	</div>

	<ng-container *ngIf="customer">
		<ul @grow class="list-group list-group-flush p-0 m-0">
			<li class="list-group-item note-row" *ngFor="let note of posNotes ">
				<div class="note-col note-type">
					<div class="field">
						<label class="field-label">Note Type</label>
						<div class="control">
							<select class="select" required (change)="updateTopic({ value: $event.target.value }, note)" [value]="note.note_code">
								<option *ngFor="let type of notetypes" [value]="type">{{type}}</option>
							</select>
						</div>
					</div>
				</div>
				<div class="note-col note-text">
					<div class="field full-width">
						<label class="field-label">Note</label>
						<div class="input-wrap">
							<input class="input" #noteInput required placeholder="Note" name="note[{{note.noteid}}]" [attr.data-noteid]="note.noteid" [value]="note.note" (input)="updateNote($event, note)" >
							<div class="input-actions">
								<button 
									*ngIf="speechRecognitionService?.getIsSupported()"
									type="button"
									class="icon-button"
									[title]="(isVoiceRecordingNote && currentVoiceNoteId === note.noteid) ? 'Stop Recording' : 'Record to this note'"
									(click)="$event.preventDefault();$event.stopPropagation();toggleVoiceEditNote(note);"
									[class.voice-active]="isVoiceRecordingNote && currentVoiceNoteId === note.noteid">
									<i class="material-icons" [class.text-warning]="isVoiceRecordingNote && currentVoiceNoteId === note.noteid" [class.voice-pulse]="isVoiceRecordingNote && currentVoiceNoteId === note.noteid">{{ (isVoiceRecordingNote && currentVoiceNoteId === note.noteid) ? 'mic' : 'mic_none' }}</i>
									<span class="badge badge-recording" *ngIf="isVoiceRecordingNote && currentVoiceNoteId === note.noteid">Recording…</span>
								</button>
								<button type="button" class="icon-button" (click)="removeNote(note.noteid)" *ngIf="note.noteid > 0 "><i class="material-icons remove-icon">remove</i></button>
							</div>
						</div>
					</div>
				</div>
			</li>
		</ul>
	</ng-container>
</ng-container>



<ng-container *ngIf="customer_creation">
	<div class="row">
		<div class="col-md-12  d-flex justify-content-center ">
			<button class="w-100 btn btn-primary" (click)="addNote($event);" id="addnote">Add Note</button>
		</div>

	</div>

		<ng-container *ngIf="customer">
			<ul @grow class="list-group list-group-flush p-0 m-0">
				<li class="list-group-item note-row" *ngFor="let note of posNotes ">
				<div class="note-col note-type">
					<div class="field">
						<label class="field-label">Note Type</label>
						<div class="control">
							<select class="select" required (change)="updateTopic({ value: $event.target.value }, note)" [value]="note.note_code">
								<option *ngFor="let type of notetypes" [value]="type">{{type}}</option>
							</select>
						</div>
					</div>
				</div>
				<div class="note-col note-text">
					<div class="field full-width">
						<label class="field-label">Note</label>
						<div class="input-wrap">
							<input class="input" #noteInput required placeholder="Note" name="note[{{note.noteid}}]" [attr.data-noteid]="note.noteid" [value]="note.note" (input)="updateNote($event, note)" >
							<div class="input-actions">
								<button type="button" class="icon-button" (click)="removeNote(note.noteid)" *ngIf="note.noteid > 0 || customer_creation"><i class="material-icons remove-icon">remove</i></button>
							</div>
						</div>
					</div>
				</div>
			</li>
		</ul>
	</ng-container>
</ng-container>
